import {trackEvent} from '../../analytics/modules/actions'
import {
  Action,
  Category,
  Entity,
  ErrorContext,
  Team
} from '../../analytics/types/Events'
import {
  AuthenticationFlows,
  AuthenticationMethod,
  SourceComponentType
} from '../types/Auth'
import {getAuthenticationOrigin} from './authenticationOrigin'

type AuthenticationErrorArgs = ErrorContext & {
  sourceComponent?: SourceComponentType | null
  authenticationMethod?: AuthenticationMethod | string
  flow?: AuthenticationFlows | null
}

/**
 * Source, method and flow fall back to the persisted attempt: Redux is gone
 * after the social redirect.
 * @param error - Error context, plus anything the caller already knows
 */
export const authenticationErrored = (error: AuthenticationErrorArgs) => {
  const {sourceComponent, authenticationMethod, flow, ...errorContext} = error
  const origin = getAuthenticationOrigin()

  return trackEvent({
    category: Category.System,
    entity: Entity.Authentication,
    action: Action.Errored,
    component: sourceComponent ?? origin.sourceComponent,
    team: Team.Retention,
    payload: {
      authenticationMethod: authenticationMethod ?? origin.authenticationMethod,
      ...origin.analyticsData,
      authenticationFlow: flow ?? origin.authenticationFlow,
      errorContext
    }
  })
}
